import React, {useState} from 'react';
import type {Optional} from 'utility-types';
import {i18n} from '@netx/core/i18n';
import {
	getMinimumPasswordLength,
	getRegexFromPasswordPrefs,
	getPasswordPatternText,
} from '@netx/core-auth/utils';
import {TextField, type TextFieldProps} from '@netx/core-components/TextField';

export interface PasswordFieldProps
	extends Optional<TextFieldProps, 'label' | 'name'> {
	/** is this the password confirm field? */
	isConfirm?: boolean;
	/** is this a new password prompt or just general password entry? */
	isNewPassword?: boolean;
}

export const PasswordFieldPrimitive = ({
	isConfirm,
	isNewPassword,
	...props
}: PasswordFieldProps) => {
	const [passwordPattern] = useState(getRegexFromPasswordPrefs());
	const [minimumPaswordLength] = useState(getMinimumPasswordLength());

	return (
		<TextField
			autoComplete={isNewPassword || isConfirm ? 'new-password' : 'password'}
			label={
				isConfirm ? i18n.t('i18n.confirmPassword') : i18n.t('i18n.password')
			}
			name={isConfirm ? 'password2' : 'password1'}
			type="password"
			helperText={isConfirm ? undefined : getPasswordPatternText()}
			{...props}
			inputProps={{
				pattern: passwordPattern
					.toString()
					.substring(1, passwordPattern.toString().length - 1),
				minLength: minimumPaswordLength,
				...props?.inputProps,
			}}
		/>
	);
};

/**
 * Wrapper for the `TextField` component that acts as a password input and utilizes system preferences for password requirements.<br/>
 * The component may optionally act as a password confirmation field.
 */
export const PasswordField = PasswordFieldPrimitive;

export default PasswordField;
